import { useLocations } from 'core/custom-hooks/use-locations.hook';
import { TrainingProgramInfo } from 'core/contexts/training-programs/domain';
import { useTrainingProgramsInfo } from 'core/custom-hooks/use-training-programs-info.hook';
import React, { useEffect, useState } from 'react';
import { RuleActionType } from '../constants/backend-enums';
import { AutomationRuleOption, useAutomationRuleOptionsState } from '../hooks/use-automation-rule-options-state';
import { ActionsLayout } from '../layouts/actions.layout';
import { ActionsExternalOptions, TriggerActionDataParams } from '../types/automation-rules.type';

export type { ActionsExternalOptions } from '../types/automation-rules.type';

const mapTrainingsToDropdown = (trainings: TrainingProgramInfo[]) =>
    trainings.map((training) => {
        const { stages, ...otherProps } = training;
        return {
            ...otherProps,
            value: training.id,
            text: training.name,
            children: stages?.map((child) => ({ value: child.id, text: child.name })),
        };
    });

interface ActionsContainerProps {
    defaultOptions: AutomationRuleOption[];
    newActionDefault: React.ReactElement;
    onAddDeleteGlobalState: (data: TriggerActionDataParams) => void;
}

export const ActionsContainer = (props: ActionsContainerProps) => {
    const { defaultOptions, newActionDefault, onAddDeleteGlobalState } = props;
    const { locations } = useLocations();
    const { options, onDeleteOptionHandler, onAddOptionHandler } = useAutomationRuleOptionsState({
        defaultOptions,
        newOptionDefault: newActionDefault,
        onAddDeleteGlobalState,
    });

    const [externalOptions, setExternalOptions] = useState<ActionsExternalOptions>({} as ActionsExternalOptions);
    const { trainingProgramsInfo, refreshTrainingProgramsInfo, isLoading } = useTrainingProgramsInfo();

    useEffect(() => {
        refreshTrainingProgramsInfo();
    }, []);

    useEffect(() => {
        setExternalOptions((prev) => ({
            ...prev,
            [RuleActionType.assign_location]: locations,
        }));
    }, [locations]);

    useEffect(() => {
        setExternalOptions((prev) => ({
            ...prev,
            [RuleActionType.enroll_training_program]: mapTrainingsToDropdown(trainingProgramsInfo),
        }));
    }, [trainingProgramsInfo]);

    return (
        <ActionsLayout
            options={options}
            isLoading={isLoading}
            onDeleteOptionHandler={onDeleteOptionHandler}
            onAddActionHandler={onAddOptionHandler}
            externalOptions={externalOptions}
        />
    );
};
